module.exports = __webpack_public_path__ + "img/4.a41676a3.jpg";